module.exports = __webpack_public_path__ + "img/pass_left.15ed886d.jpg";